import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';

import GlobalActivityHistoryView from '@/modules/global-events/views/GlobalActivityHistoryView.vue';

export const globalEventsModule = createModuleBuilder()
    .registerRoutes(() => [
        {
            path: '/:rpId?/configuration/activity-history',
            name: 'configurationActivityHistory',
            component: GlobalActivityHistoryView as any,
            meta: { title: 'Activity History', pageClass: 'GlobalActivityHistoryView' },
        },
    ])
    .demandContext<{ gatewayClient: GatewayApiClient }>()
    .end();
